import { Home } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { DashboardPage } from './pages/DashboardPage'

/**
 * Dashboard — M10. The landing page at `/`.
 *
 * Sprint 13a (2026-04-26): surfaced from `'hidden'` to `'home'` so it
 * appears in the sidebar's Home section. Users still reach it by
 * clicking the SPI Ops brand logo or pressing `g h`; the sidebar item
 * is an additional affordance (the Phase 3 sectioning model treats
 * the dashboard as a first-class module).
 */
export default defineModule({
  id: 'dashboard',
  name: 'Home',
  shortName: 'Home',
  icon: Home,
  navSection: 'home',
  navOrder: 10,
  urlNamespace: '/',
  routes: [{ path: '/', element: DashboardPage, label: 'Today' }],
  // outside_sales_rep excluded (2026-07-21): password-login field reps get
  // a narrowed sidebar (Orders + Quotes only) — no Home/Dashboard.
  permissions: [
    'admin', 'sales', 'inside_sales_rep',
    'operations', 'operations_logistics', 'purchasing', 'regulatory', 'finance', 'viewer',
  ],
  densityDefault: 'comfortable',
  mobileStrategy: 'responsive',

  keyboardShortcut: 'g h',

  commandPaletteEntries: [
    {
      label: 'Go to Home',
      keywords: ['home', 'dashboard', 'today', 'attention'],
      path: '/',
      group: 'modules',
      shortcut: 'g h',
    },
  ],
})
